export function CoreEditableCellDirective ($timeout, KEYCODES) {
  return {
    restrict: 'A',
    link (scope, element) {
      function handleKeydown ( e ) {
        var keyCode = e.keyCode || e.which;

        if (keyCode === KEYCODES.tab && !e.shiftKey) {
          var parent = $('.ngCell').has(element);

          e.preventDefault();

          $timeout(() => {
            scope.$emit('ngGridEventEndCellEdit');
            parent.nextAll().has('[ng-cell-has-focus]').find('[ng-cell-has-focus]').has('[editable="true"]').first().trigger('click');
          });
        }
      }

      element.on('keydown', handleKeydown);

      scope.$on('$destroy', () => {
        element.off('keydown', handleKeydown);
      });
    }
  };
}